module.exports = __webpack_public_path__ + "static/media/hearthstone-min.2fd30f6a.png";